import { useEffect, useState } from "react";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import {
  MainSidebar,
  PageTitle,
  MainContent,
  PageTitleWrapper,
} from "../EditorStyles";
import { FormattedMessage } from "react-intl";
import MainContentPlaceholder from "../BaseComponents/MainContentPlaceholder";
import { Pano } from "../../../types";
import NoDataNotice from "../BaseComponents/NoDataNotice";
import { useEditState } from "../EditContext";
import SinglePanoPage from "./SinglePanoPage";
import { useAppState } from "../../../AppContext";
import { MenuItemTitle, StyledMenuItem } from "../../Sidebar/MenuItemStyles";
import { makeKeyDownHandler } from "../../../utils/a11y-utils";

const PanoPage = () => {
  const { target, setTarget } = useEditState();
  const { state } = useAppState();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/editor/pano" && target) {
      setTarget(undefined);
    }
  }, [location.pathname, setTarget, target]);

  return (
    <div style={{ overflowY: "auto" }}>
      {state.panos.length === 0 ? (
        <NoDataNotice />
      ) : (
        <div>
          {state.panos.map((pano: Pano) => (
            <StyledMenuItem key={pano.id} className={target === pano.id ? "active" : ""}>
              <div
                onClick={() => history.push(`/editor/pano/${pano.id}/${pano.scenarios[0].slug}`)}
                onKeyDown={makeKeyDownHandler(() => history.push(`/editor/pano/${pano.id}/${pano.scenarios[0].slug}`))}
                role="button"
                tabIndex={0}
              >
                <MenuItemTitle>{pano.title}</MenuItemTitle>
              </div>
            </StyledMenuItem>
          ))}
        </div>
      )}
    </div>
  );
};

export default PanoPage;
